import axios from "axios"
import { baseUrl } from "./url"

const Axios = axios.create({
    baseURL: baseUrl,
})

export const api = async (isAdmin, url, type, data, headers, params = {}) => {

    let requestTypes = [ 'get', 'post', 'put', 'delete' ]
    let requestType = requestTypes.find((reqType) => { return reqType === type })

    const localuser = JSON.parse(localStorage.getItem('localuser') || '{}')
    const token = localStorage.getItem('MemberAuth') || localuser.token || ''
    const memberId = localStorage.getItem('MemberId') || localuser.memberId || ''
    const memberCode = localStorage.getItem('MemberCode') || localuser.memberCode || ''

    // Add both lowercase and uppercase header keys to be safe with backends that
    // read headers case-sensitively or with different casing.
    const newHeaders = {
        ...(token ? { authorization: `Bearer ${token}` } : {}),
        ...(memberId ? { memberid: memberId } : {}),
        ...(memberCode ? { membercode: memberCode } : {}),
        ...headers,
    }

    if(requestType){
        try{
            const response = await Axios({ method: requestType, url: url, data: data, headers: newHeaders, ...params })
            return response
        }catch(e){
            if(e?.response?.status === 401) {
                localStorage.clear();
                console.log("🚀 ~ e?.response?.status === 401:");
                window.location.href = isAdmin ? '/admin' : '/'
                alert("Session expired, please login again")
            }
            return Promise.reject(e)
        }
    }else{
        return Promise.reject("invalid request type")
    }
}
